export const Loading = require('../resources/img/loading.gif');
export const Back = require('../resources/img/cheveronback.webp');
export const Logo = require('../resources/img/image.png');
export const PCLOGO = require('../resources/img/PCLOGO.png');
export const Search = require('../resources/img/search.png');
export const Download = require('../resources/img/Download_Icon.png');
export const DownloadIcon = require('../resources/img/down.jpeg');
export const Upload = require('../resources/img/upload.png');
export const BackArrow = require('../resources/img/back.png');
export const Edit = require('../resources/img/edit.png');
export const Close = require('../resources/img/CloseFilled.png');
export const Info = require('../resources/img/Info.png');
export const Cover = require('../resources/img/cover.png');
export const Lock = require('../resources/img/lock.png');
export const Home = require('../resources/img/home.png');
export const Warning = require('../resources/img/Warning.png');
export const LoginBack = require('../resources/img/loginBack.png');
export const Delete =  require('../resources/img/delete.png');
export const Guided =  require('../resources/img/guided.png');
export const BG =  require('../resources/img/BG.png');
export const Cheveron =  require('../resources/img/cheveron.png');
